import { query } from '@glitz/core';

// This file must be able to be used on both server- (Node) and client side bundles

const enum Breakpoint {
  Mobile = 768,
  Tablet = 1280,
  Laptop = 1920,
}

export const maxMobileViewportMediaQuery = query({ maxWidth: `${Breakpoint.Mobile}px` });
export const maxSmallViewportMediaQuery = query({ maxWidth: `${Breakpoint.Tablet}px` });
export const minMediumViewportMediaQuery = query({ minWidth: `${Breakpoint.Mobile + 1}px` });
export const minLargeViewportMediaQuery = query({ minWidth: `${Breakpoint.Tablet + 1}px` });
export const minXLargeViewportMediaQuery = query({ minWidth: `1440px` });
export const minHugeViewportMediaQuery = query({ minWidth: `${Breakpoint.Laptop}px` });

export const mediaQueryOrder = [
  maxSmallViewportMediaQuery,
  minMediumViewportMediaQuery,
  minLargeViewportMediaQuery,
  minXLargeViewportMediaQuery,
  minHugeViewportMediaQuery,
];
